import React from 'react';

import Label from './Label';

// the `data` prop is an object with the shape:
// {
//   errors?: Errors
//   [name]: any
// }

const TextField = ({ name, title, data, onChange, readOnly, onClick }) => {
  return (
    <div>
      <Label attr={name} text={title} errors={data.errors} />
      <input
        type="text"
        id={name}
        name={name}
        value={data[name]}
        onChange={onChange}
        readOnly={readOnly}
        onClick={onClick}
      />
    </div>
  );
};

export default TextField;
